/* ==============================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
============================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// @mui material components
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import Navbar from 'examples/Navbars/NavBar';
import { APP_STATE } from 'services/Define';
import PicImage from './PicImage';
import PicProduct from './PicProduct';
import PicExportStore from './PicExportStore';

// Component

const menu = [
  { code: 'pic_image' },
  { code: 'pic_product' },
  { code: 'pic_exportstore' },
  { code: 'pic_importstore' },
  { code: 'pic_exportmove' },
  { code: 'pic_shippingbranch' },
  { code: 'pic_pickupstore' },
  { code: 'pic_productionreceive' },
  { code: 'pic_purchaserequest' },
  { code: 'pic_receive' },
  { code: 'pic_receivestore' },
  { code: 'pic_returnstore' },
  { code: 'pic_counting' },
  { code: 'pic_poscancel' },
  { code: 'pic_poscloseshift' },
  { code: 'pic_posdrop' },
  { code: 'pic_posreturn' },
  { code: 'pic_ticket' },
];

function Picture() {
  const mod = 'picture';
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const app = useSelector((state) => state[APP_STATE]);

  const setBtnBadge = (name, link, key) => {
    return (
      <Grid item xs={12} key={key}>
        <MDButton color='light' href={link} fullWidth>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'left',
              width: '100%',
              gap: 1,
              fontSize: 15,
              fontWeight: 400,
            }}
          >
            {key}. {name}
          </Box>
        </MDButton>
      </Grid>
    );
  };

  const renderButton = () => {
    return (
      <MDBox mb={7}>
        <Card sx={{ p: 2 }}>
          <Grid container spacing={1}>
            {menu.map((item, i) =>
              setBtnBadge(t(`menu.${item.code}`), `/${mod}/${item.code}`, i + 1)
            )}
          </Grid>
        </Card>
      </MDBox>
    );
  };

  const renderPicture = () => {
    if (id === 'pic_image') return <PicImage />;
    if (id === 'pic_product') return <PicProduct />;
    if (id === 'pic_exportstore') return <PicExportStore />;

    return (
      <MDBox>
        <Navbar route={[t(`menu.setting`), t(`menu.picture`)]} />
        <MDBox py={3}>{renderButton()}</MDBox>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);
  }, [id]);

  return (
    <DashboardLayout>
      {renderPicture()}
      <Footer />
    </DashboardLayout>
  );
}

export default Picture;
